// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"d","contentFrame":"e","buttonGroup":"f","button":"h","header":"i","text":"j","contentImage":"k"};